export { default as dark } from './dark';
export { default as light } from './light';



// WEBPACK FOOTER //
// ./src/@ui/theme/types/index.js